import { ReactNode } from "react";

interface BadgeProps {
  extra: string;
  children?: ReactNode;
}

export function Badge(props: BadgeProps) {
  return <div className={`flex w-max px-2 py-1 rounded text-xs ${props.extra}`}>{props.children}</div>;
}